import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { DistrictComponent } from './district/district.component';
import { OfficesComponent } from './offices/offices.component';
import { ServicesComponent } from './services/services.component';
import { ContactsComponent } from './contacts/contacts.component';


const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'quartier-rueil-malmaison', component: DistrictComponent },
  { path: 'bureaux-rueil-malmaison', component: OfficesComponent },
  { path: 'services-immeuble', component: ServicesComponent },
  { path: 'contact-voyager', component: ContactsComponent },
  { path: '**', redirectTo: '/' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts